import { useCallback } from 'react';

import { boundActionsFactory } from '@/packages/redux-state/store';
import { type TViewMode } from '@/packages/redux-state/store/slices/listingLayout/slice';
import { activePinSelector } from '@/packages/redux-state/store/slices/mapControls/selectors/dumb';

import { useReduxState } from '../context/ReduxStoreContext';
import { setHybridSearchModeCookie } from '../utils/cookies';

const useBoundActions = boundActionsFactory(reduxActions => ({
  setViewMode: reduxActions.listingLayout.setViewMode,
  clearActivePin: reduxActions.mapControls.clearActivePin,
  setIsPageReloading: reduxActions.browserPage.setIsPageReloading,
}));

type TUseViewModeChange = (nextView: TViewMode, scrollTopOffset?: number) => Promise<void>;

export const useViewModeChange = (): TUseViewModeChange => {
  const boundActions = useBoundActions();

  const reduxStore = useReduxState();

  return useCallback(
    async (nextView: TViewMode, scrollTopOffset = 0) => {
      const activePin = activePinSelector(reduxStore.getState());

      /**
       * Браузеру тяжело перерисовывать все карточки при смене вида (если фризы).
       * Поэтому сначала переключаем на скелетон, а потом уже меняем вид.
       */
      boundActions.setIsPageReloading(true);

      boundActions.setViewMode(nextView);

      if (nextView !== 'map') {
        setHybridSearchModeCookie(nextView);
      }

      window.scrollTo({ top: scrollTopOffset });

      if (activePin) {
        boundActions.clearActivePin();
      }

      setTimeout(() => {
        boundActions.setIsPageReloading(false);
      });
    },
    [boundActions, reduxStore],
  );
};
